import { StreamChat } from 'stream-chat';

const apiKey = process.env.REACT_APP_GET_STREAM_API_KEY;
const sort = { last_message_at: -1 } as const;

const initChat = async (data: any) => {
  const filters = {
    type: 'messaging',
    members: { $in: [String(data?.uuid)] },
  };
  const blastfilters = {
    type: 'blast_group',
    members: { $in: [String(data?.uuid)] },
  };

  const client = StreamChat.getInstance(apiKey as any);
  await client.connectUser(
    {
      id: data?.uuid,
    },
    data?.streamAccessToken
  );

  const channels = await client.queryChannels(filters, sort, {
    watch: true,
    state: true,
    limit: 100,
  });
  const blastchannels = await client.queryChannels(blastfilters, sort, {
    watch: true,
    state: true,
    limit: 100,
  });

  return { channels, client, blastchannels };
};

export default initChat;
